import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import { cognitoAddUser as cognitoAddUserMutation } from '../graphql/mutations'

export const useCognito = () => {
  const client = useMemo(() => generateClient(), [])
  const cognitoAddUser = useCallback(
    async (accessCode, groupName, userId) => {
      return client.graphql({
        query: cognitoAddUserMutation,
        variables: { input: { accessCode, groupName, userId } },
      })
    },
    [client],
  )

  return {
    cognitoAddUser,
  }
}
